
import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import UserManagementHeader from './UserManagementHeader';
import UsersList from './UsersList';
import ActiveDirectory from './active-directory';

interface UserManagementProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const UserManagement: React.FC<UserManagementProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <Card>
      <CardHeader className="pb-2">
        <UserManagementHeader
          editing={editing}
          onEditToggle={onEditToggle}
          onSave={onSave}
        />
      </CardHeader>
      <CardContent className="space-y-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid grid-cols-2 sm:w-auto w-full">
            <TabsTrigger value="users">Users</TabsTrigger>
            <TabsTrigger value="directory">Active Directory</TabsTrigger>
          </TabsList>
          
          <TabsContent value="users" className="space-y-6">
            <UsersList editing={editing} />
          </TabsContent>
          
          <TabsContent value="directory" className="space-y-6">
            <ActiveDirectory editing={editing} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default UserManagement;
